import React, { Component } from 'react';

import { DropTarget, DragSource } from 'react-dnd'
import AddJumpers from './modals/addJumpers'
import CancelJump from './modals/cancelJump'
import RemovableJumper from './modals/removableJumper'
import EditableJumper from './modals/editableJumper'
import CreatableJumper from './modals/creatableJumper'
import { Card, CardBody, Row, Col, CardFooter } from 'reactstrap'
import loadsStore from '../../stores/loads-store';
import ReactDOM from 'react-dom';
import GooglePicker from 'react-google-picker';
import jumpersStore from '../../stores/jumpers-store';
import returnLoadSettings from '../helpers/returnLoadSettings';
import TandemNestedMenu from './NestedMenus';

const Types = {
  ITEM: 'JUMP'
};

const itemSource = {
  beginDrag(props) {
    //console.log('dragging');
    const item = props
    return item
  },
  endDrag(props, monitor, component) {
    //console.log('endrag')
    if (!monitor.didDrop()) {
      return;
    }
    //return props.handleJumperDrop(props)
    return props;
  }
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}


class RenderTandemJump extends Component {
  constructor() {
    super();
    this.state = {
      optionMenu: false,
      optionSub: false,
      copyOptionSub: false,
      cutOptionSub: false
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);

  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    let id;
    if (document.querySelector('#copy-tandem-menu')) {
      id = document.querySelector('#copy-tandem-menu')
    } else {
      id = document.querySelector('#move-tandem-menu')
    }
    if (!domNode || !domNode.contains(event.target)) {
      if (this.state.optionMenu) {
        if (!id) {
          this.setState({
            optionMenu: false,
            optionSub: false
          });
        }
      }
    }
  }

  renderTandemLabel = (tandemJump) => {

    var text = tandemJump.displayText;
    if (tandemJump.videoPackageName) {
      text = text + "\n" + tandemJump.videoPackageName;
    }
    return text;
  }

  toggleOptions = () => {
    this.setState({
      optionMenu: !this.state.optionMenu
    })
  }

  handleDelete = (jumpId) => {
    document.getElementById(jumpId).click();
  }

  showWidget = (widget) => {
    widget.open()
  }


  processWidgetUpload = (error, result) => {
    // console.log('after upload');
    if (error) {
      console.log(error);
    }
    // console.log(result.event);
    if (result.event === "queues-end") {
      var payload = {
        jumperId: this.props.tandemJump.student._id,
        videographerId: this.props.tandemJump.videographer._id,
        jumpId: this.props.jumpId,
        loadId: this.props.load._id,
        jumpType: "tandem"
      }

      setTimeout(
        () => jumpersStore.sendTandemMediaEmail(payload),
        5000
      );
      //loadsStore.updateCompletedTandemMediaFolder(this.props.loadId, this.props.jumpId, {videoUploaded: true, jumpType: "Tandem"});
      // console.log(result);
    }
    if (!error && result && result.event === "success") {
      // console.log('Done! Here is the image info: ', result.info);
      if (result.info.status !== "pending") {
        var tags = result.info.tags;
        var jumpType = result.info.tags[2];
        var jumpId = result.info.tags[1];
        var jumperId = result.info.tags[0];
        if (jumpType === "tandem") {
          var payload = { jumpType: "tandem", url: result.info.url, resource_type: result.info.resource_type };
          jumpersStore.addMediaUrl(this.props.tandemJump.student._id, payload);
        }
      }

    }
  }

  createWidget = (jumperId, jumpId, jumpType, othertag, preset, position) => {
    var widget = window.cloudinary.createUploadWidget({
      cloudName: 'dizio',
      uploadPreset: preset,
      showCompletedButton: true,
      tags: [jumperId, jumpId, jumpType, othertag, this.props.load._id, this.props.tandemJump.videographer._id],
      sources: [
        "local"
      ],
      queueViewPosition: position,
      folder: 'test'
    }, this.processWidgetUpload
    );
    widget.open();
  }

  handleCopyClick = (tandem = this.props.tandemJump, loadNum = this.props.loadNum, uid = -1000) => {
    this.setState({
      copyOptionSub: true
    })
    // console.log('Copyclicked', tandem, loadNum);
    var payload = {};
    payload = tandem
    var today = new Date();
    var isWeekend = today.getDay() % 6 === 0;
    payload.isWeekend = isWeekend
    payload.instructorId = tandem.instructor['_id']
    payload.studentId = tandem.student['_id']
    payload.videographerId = tandem.videographer['_id']
    loadsStore.copied = true;
    loadsStore.copyValue = payload;
    loadsStore.cut = false;
    // this.props.toggleToster(true, "copied")
    // var element = document.getElementById(uid);
    // element.style.display = "none";
    if (uid !== -1000) {
      var element = document.getElementById(uid);
      element.style.display = "none";
    }

  }

  handleCutClick = (tandem = this.props.tandemJump, loadNum = this.props.loadNum, uid, jumpId = this.props.jumpId) => {
    this.setState({
      cutOptionSub: true
    })
    var payload = {};
    payload = tandem
    var today = new Date();
    var isWeekend = today.getDay() % 6 === 0;
    payload.isWeekend = isWeekend
    payload.instructorId = tandem.instructor['_id']
    payload.studentId = tandem.student['_id']
    payload.videographerId = tandem.videographer['_id']
    loadsStore.cut = true;
    loadsStore.cutValue = { loadNum, jumpId }
    loadsStore.copyValue = payload;
  }

  handleCopyPasteClick = (loadNum) => {
    this.setState({
      optionMenu: !this.state.optionMenu,
      copyOptionSub: !this.state.copyOptionSub,
      cutOptionSub: !this.state.cutOptionSub
    })
    var Value = loadsStore.copyValue;
    // console.log("pasteclicked", loadNum, Value);
    if (Value.tandemPackageName) {
      loadsStore.createTandemJump(loadNum, Value).then(d => {
        // console.log("TandemJump in pasted", d);
        if (d) {
          if (loadsStore.cut) {
            loadsStore.cut = false;
            const { loadNum, jumpId } = loadsStore.cutValue;
            loadsStore.cancelTandemJump(loadNum, jumpId);
          }
        }
      })
    }

  };

  viewGallery = (tag) => {
    // console.log('view gallery');
    var myGallery = window.cloudinary.galleryWidget({
      container: "#my-gallery",
      cloudName: "dizio",
      mediaAssets: [
        { tag: "test", mediaType: "video" }
      ]
    });
    myGallery.render();
  }
  render() {
    console.log('rendering tandem jump on load ' + this.props.loadNum);

    const { tandemJump, loadNum, jumpId, tandemInstructorOptions, videographerOptions, isDragging, connectDragSource, tandemStudentOptions, loadId, isJumperRole, loadsToShow, columnsPerGroup, fontSize } = this.props;

    var uid = "tandem" + loadNum + "_" + jumpId;

    var IsdisplayOnly = loadsStore.displayOnly ? 'none' : '';

    var backgroundBaseColor = '13A289';

    var backgroundInt = parseInt(backgroundBaseColor, 16);

    var altInt = parseInt(tandemJump.altitude, 16);

    // console.log(altInt);

    var backgroundColor;

    if (altInt < 18) {
      backgroundColor = '#13B239';
    }
    else if (altInt >= 18 && altInt <= 23) {
      backgroundColor = '#FF6347';
    }
    else {
      backgroundColor = '#1E90FF';
    }

    var videoColor = "black";
    if (tandemJump.mediaEmailSent) {
      videoColor = "green";
    }

    // console.log("backgroundColor: ", backgroundColor);

    var role = localStorage.getItem("role");
    const { settingsMoreThan4 } = returnLoadSettings(loadsToShow, columnsPerGroup, fontSize)


    return connectDragSource(
      // <div style={{ pointerEvents: IsdisplayOnly }}>
      <div >
        {/* {
          this.state.optionSub &&
          <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '75px', left: '132px' }}>
            {
              this.props.loads.map((load, i) => {
                if (load.loadNum != loadNum) {
                  return (<li>
                    <span onClick={() => this.handleCopyPasteClick(load.loadNum)}>{"Load " + load.loadNum}</span>
                  </li>)
                }
              })
            }
          </ul>
        } */}
        {
          this.state.optionMenu &&
          <ul className="menu-option" style={{ pointerEvents: 'auto' }}>
            {
              !this.props.isCompleted &&
              <li>
                <span style={{ color: 'red' }} onClick={() => this.handleDelete("delete-jump" + jumpId)}>Delete</span>
              </li>}

            {!this.props.isCompleted &&
              <TandemNestedMenu
                txt={"Copy"}
                loadNum={this.props.loadNum}
                loads={loadsStore.getActiveLoadsForDisplay()}
                handleCopyClick={this.handleCopyClick}
                handleCopyPasteClick={this.handleCopyPasteClick}
                id={"copy-tandem-menu"}
              />}
            {!this.props.isCompleted &&
              <TandemNestedMenu
                txt={"Move"}
                loadNum={this.props.loadNum}
                loads={loadsStore.getActiveLoadsForDisplay()}
                handleCopyClick={this.handleCutClick}
                handleCopyPasteClick={this.handleCopyPasteClick}
                id={"move-tandem-menu"}
              />}
            {/* <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 500) }}>
              <span onClick={() => this.handleCopyClick(tandemJump, loadNum, -1000)} onMouseOver={() => { setTimeout(() => { this.handleCopyClick(tandemJump, loadNum, -1000) }, 500) }}>Copy</span>
              {
                this.state.copyOptionSub &&
                <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ copyOptionSub: false }) }, 500) }}>
                  {
                    this.props.loads.map((load, i) => {
                      if (load.loadNum != loadNum) {
                        return (<li>
                          <span onClick={() => this.handleCopyPasteClick(load.loadNum)} >{"Load " + load.loadNum}</span>
                        </li>)
                      }
                    })
                  }
                </ul>
              }
            </li>
            {!this.props.isCompleted && <li style={{ position: "relative" }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
              <span style={{ color: 'red' }} onClick={() => this.handleCutClick(tandemJump, loadNum, uid, jumpId)} onMouseOver={() => { setTimeout(() => { this.handleCutClick(tandemJump, loadNum, uid, jumpId) }, 500) }}>Move</span>
              {
                this.state.cutOptionSub &&
                <ul className="menu-option" style={{ zIndex: '100', position: 'absolute', top: '0px', right: '167px' }} onMouseLeave={() => { setTimeout(() => { this.setState({ cutOptionSub: false }) }, 500) }}>
                  {
                    this.props.loads.map((load, i) => {
                      if (load.loadNum != loadNum) {
                        return (<li>
                          <span onClick={() => this.handleCopyPasteClick(load.loadNum)} >{"Load " + load.loadNum}</span>
                        </li>)
                      }
                    })
                  }
                </ul>
              }
            </li>} */}
            {/*this.props.isCompleted
              && role == 'video edit'
              &&
              <li>
                <span onClick={() => this.createWidget(tandemJump.student._id, tandemJump.jumpId, "tandem", "test", window.ENV?.videoUploadPreset, 'right:105px')}>Upload Video</span>
                {tandemJump.videoUrl !== undefined ? <i class="fa fa-check" aria-hidden="true"></i> : null}
              </li>
            */}
            {/*this.props.isCompleted
              && role == 'video edit'
              &&
              <li>
                <span onClick={() => this.createWidget(tandemJump.student._id, tandemJump.jumpId, "tandem", "test", window.ENV?.picsUploadPreset, 'right:35px')}>Upload Pics</span>
                {tandemJump.galleryUrl !== undefined ? <i class="fa fa-check" aria-hidden="true"></i> : null}
              </li>
            */}
            {/*
              this.props.isCompleted && tandemJump.galleryUrl &&
              <li>
                <span onClick={() => window.open(tandemJump.galleryUrl, "_blank")}>View Gallery</span>
              </li>
            */}
            {role == 'video edit' &&
              <li>
                <span onClick={() => { navigator.clipboard.writeText(tandemJump.student.email) }} >email: {tandemJump.student.email}</span>
              </li>
            }
            {role == 'video edit' &&
              <li>
                <span onClick={() => { navigator.clipboard.writeText(tandemJump.student.phone) }}>phone: {tandemJump.student.phone}</span>
              </li>
            }

          </ul>
        }
        <Card className="jumpcard" >
          {/* <CardHeader className="jumpcardheader align-items-center row">
                        <div className="col-10">
                            Tandem Jump
                                </div>
                        <div className="col-2">
                            <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"tandemJump"} />
                        </div>
                    </CardHeader> */}
          {!this.props.isCompleted && <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"tandemJump"} />}

          <CardBody style={{ padding: '0px !important' }}>

            {/* <ul className="list-unstyled">
                                    <li style={listStyle}>
                                        <EditableJumper type={"tandem"} label={"I"} loadNum={loadNum} jumpId={jumpId} jumper={tandemJump.instructor} options={tandemInstructorOptions} />

                                    </li>
                                    <li style={listStyle}>
                                        <button className="btn lightBlueButton jumper-name" >
                                            <b>S: </b> {tandemJump.student.firstname} {tandemJump.student.lastname}

                                        </button>
                                    </li>
                                    {tandemJump.videoType === "outside" || tandemJump.videoType === "both"  ?
                                        <li style={listStyle}>
                                            <EditableJumper type={"tandem"} label={"V"} loadNum={loadNum} jumpId={jumpId} jumper={tandemJump.videographer} options={videographerOptions} />

                                        </li> : null
                                    }
                                </ul> */}


            <Row>
              <div className={settingsMoreThan4 ? "funjumptype custom-col" : "funjumptype col-3"} style={{ backgroundColor: backgroundColor }}>
                <strong>{this.renderTandemLabel(tandemJump)}</strong>

              </div>
              <div className={settingsMoreThan4 ? "cardmiddle jumpers-container" : "cardmiddle col-9"}>
                <ul className="tandem-load" >
                  <li>
                    <EditableJumper activeJumperIdsOnLoad={this.props.load.activeJumperIds} type={"tandem"} label={"I"} loadNum={loadNum} jumpId={jumpId} jumper={tandemJump.instructor} videoType={tandemJump.videoType} />
                  </li>
                  <li>
                    <CreatableJumper type={"tandem"} loadNum={loadNum} disabled={true} jumpId={jumpId} jumper={tandemJump.student} />
                  </li>
                  {(tandemJump.videoType === "outside" || tandemJump.videoType === "both") && tandemJump.videographer !== undefined ?
                    <li>
                      <EditableJumper activeJumperIdsOnLoad={this.props.load.activeJumperIds} type={"tandem"} label={"V"} loadNum={loadNum} jumpId={jumpId} jumper={tandemJump.videographer} />
                    </li> : null
                  }
                  {tandemJump.videoType === "outside" || tandemJump.videoType === "both" ? <i className="fa fa-3x fa-video-camera" style={{ color: videoColor }}> </i> : null}

                  {tandemJump.isOverweight ? <span style={{ fontSize: '26px', }}><strong>  OW</strong></span> : null}
                  {role == 'video edit' && tandemJump.studentWeight && tandemJump.studentWeight !== "true" ? <React.Fragment><span>Weight: {tandemJump.studentWeight}</span></React.Fragment> : null}

                </ul>

                {loadsStore.displayOnly && role !== 'video edit' ? null : <div className="right-menu"
                  onClick={this.toggleOptions}
                  onBlur={this.toggleOptions}>
                  <span>
                    <i class="fa fa-ellipsis-v"></i>
                  </span>
                </div>
                }
              </div>

              {/* <Col xs="12" md="2" lg="1" className="jumpClose">
                                <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"tandemJump"} />
                            </Col> */}
            </Row>
          </CardBody>
          {tandemJump.note && window.ENV.tenant ==="montereybay" ?
            <CardFooter className="fun-card-footer" >{tandemJump.note}</CardFooter> : null}
        </Card>
      </div>
    )
  }
}


export default DragSource(Types.ITEM, itemSource, collect)(RenderTandemJump)
